<a mat-button routerLink="contact" class="courrier-font">contact us</a>
<a mat-button routerLink="faq" class="courrier-font">FAQ</a>
<p class="italic mat-body-2">
  Powered by
  <a href="https://cascade8.com/" target="_blank" class="underline">Cascade8</a> &
  <a href="http://logicalpictures.com/" target="_blank" class="underline">Logical Pictures</a>
</p>
